import { axiosGetWithCookies } from './helper';

export const fetchGlobalUsers = () => {
  return axiosGetWithCookies(`/users/users/id-name-map`);
};

export const fetchGlobalSites = () => {
  return axiosGetWithCookies(`/regions/sites/id-name-map`);
};

export const fetchGlobalBusinessClients = () => {
  return axiosGetWithCookies(`/users/business-clients/id-name-map`);
};
